import styled from 'styled-components';

export const ModalStyle = styled.div`
  .modal-content {
    min-height: 111px;

    @media (max-width: 1090) {
      min-width: 60vw;
    }
  }
  .modal-body {
    display: flex;
    align-items: center;
    justify-content: space-around;
    width: 100%;
    padding: 40px;
    height: 100%;
    p {
      font-size: 14px;
    }
    img {
      width: 32px;
      height: 32px;
      border-radius: 50%;
    }

    @media (max-width: 978px) {
      flex-flow: wrap;
    }

    .firstColumn {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-around;

      .mainDiv {
        width: 95%;
        height: 60px;
        border-radius: 3px;
        margin: 10px;
        background-color: #263340;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 13px;

        p {
          padding-top: 16px;
        }
      }

      .childrenDiv {
        display: flex;
        align-items: center;
        img {
          margin-right: 7px;
        }
      }
    }
    .secondColumn {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-around;

      .mainDiv {
        width: 95%;
        height: 60px;
        border-radius: 3px;
        margin: 10px;
        background-color: #263340;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 13px;

        p {
          padding-top: 16px;
        }
      }

      .childrenDiv {
        display: flex;
        align-items: center;
        img {
          margin-right: 7px;
        }
      }
    }
  }
`;
